<template>
<div>
    <div style="position:absolute; top: 10px; left: 10px; z-index: 999;">
        <template v-if="content == null"></template>
        <template v-else>
            <button @click="onClickOpenModal()" type="button" class="btn btn-primary">
                Invia statistiche
            </button>
            <button @click="onClickfinish()" type="button" class="btn btn-primary ms-2">
                Fine esercizio
            </button>
            <!--
            <button @click="onClickAttestato()" type="button" class="btn btn-primary ms-2">
                Attestato
            </button>
            -->
        </template>
    </div>
    
    <div class="modal fade" ref="modal" data-bs-backdrop="static" tabindex="-1" aria-labelledby="erkModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-scrollable modal-lg">
            <div class="modal-content" style="height: 500px;">
                <div class="modal-header py-2 pe-2">
                    <strong class="modal-title">Invio statistiche</strong>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-12">
                            <textarea v-model="text" class="form-control" style="height:300px;"></textarea>
                        </div>
                    </div>
                    
                    <div class="modal-footer">
                        <button @click="onClickOk()" type="button" class="btn btn-primary close-btn">
                            Ok
                        </button>
                        <button @click="onClickCancel()" type="button" class="btn btn-secondary close-btn">
                            Annulla
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <MbAttestatoView ref="attestatoModal"
        :isPatient="isPatient"
        :userId="stats.userId"
        :sessionId="stats.sessionId"></MbAttestatoView>
</div>
</template>
<script>

import MbAttestatoView from '../badge/MbAttestatoView.vue'

export default {
    name: 'MbExerciseStats',
    components: {
        MbAttestatoView
    },
    props: {
        sessionContentId: Number,
        stats: {
            type: Array,
            default(){
                return []
            }
        },
        content: Object,
        isPatient: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            text: "",
            modal: null,
        }
    },
    computed: {
    },
    mounted() {
        this.text = this.statsToText()
        this.modal = new window.bootstrap.Modal(this.$refs.modal)
    },
    methods: {
        onClickOpenModal() {
            this.modal.toggle()
        },
        statsToText(){
            let v = ""
            for (let k in this.stats) {
                v += k + ":" + this.stats[k] + '\n'
            }

            if (this.content.pack_id == 'TACHISTOSCOPIO') {
                v += "questionTime:12000\n"+
                    "score:1\n"+
                    "questionTotal:1\n" +
                    "question_num:1\n"+
                    "neuter:0\n"+
                    "parameters:" + JSON.stringify({
                        "esposizione": 10,
                        "intervallo": 20,
                        "risposta": "Orale",
                        "numero_stimoli": 10
                    })
                return v
            }

            v += "Verb:A\n"+
                "ID:PYCVINXR16FX\n"+
                "Title:Pagina 1\n"+
                "PageCount:10\n"+
                "PageNum:1\n"+
                "attempt:1\n"+
                "attemptTime:12000\n"+
                "questionTime:12000\n"+
                "exerciseTime:12000\n"+
                "questionTotal:10\n"+
                "questionNum:1\n"+
                "neuter:false\n"+
                "score:1"
            return v
        },
        textToStats(){
            let res = {}
            let rows = this.text.split('\n')
            for (let row of rows) {
                if (row.indexOf("parameters:") > -1) {
                    res.parameters = row.replace("parameters:", "")
                    continue
                }
                let [k, v] = row.split(':')
                res[k] = v
            }

            return res
        },
        onKeyDown(event) {
            if (event.ctrlKey && event.key === 'q') {
                this.modal.toggle()
            }
        },
        onClickOk() {
            let st = this.textToStats()
            
            let url = '/structure/ContentPlayAction-saveStats'
            if (this.isPatient) {
                url = '/patient/ContentPlayAction-saveStats?sessionContentId=' + this.sessionContentId
            }

            if (this.content.pack_id == 'TACHISTOSCOPIO') {
                url = '/service/tool/ServiceAction-persistStats'
            }

            window.$.post(url, st, function(data){
                console.log(data)
            });
            this.modal.toggle()
        },
        onClickCancel() {
            this.modal.toggle()
        },
        onClickfinish(){
            window.exitFunction()
        },
        onClickAttestato(){
            this.$refs.attestatoModal.toggle()
        }
    }
}

</script>